// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"44":"634680d3","94":"e8dec799","510":"dee20549","513":"9d05c7ed","863":"8d2a08cd"}[chunkId] + ".css";
};